/*eslint no-console:1 */
// import {customXHR} from '../lib/helper';
import axios from 'axios';
import styleSelect from 'styleselect';

export default class StyleSelector {

  constructor(el) {

    this.el = el;

    this.select = null;
    this.label = null;
    this.isSetup = true;
    this.isSorting = el.classList.contains('is-sorting-selector');
    this.isAmount = el.classList.contains('is-amount-selector');
    this.isIconDropdown = el.classList.contains('tc-selector-icon');
    this.styleSelect = !!el.classList.contains('tc-style-selector');
    this.cookieDomain = (window.app || {}).cookieDomain || window.location.hostname.replace(/^www./, '');
    this.init();
  }

  init() {

    this.select = this.el.querySelector('select');

    if (this.select && this.styleSelect) {

      styleSelect(this.select);
    }

    this.registerEvents();
    this.onInit();
  }

  registerEvents() {
    if (!this.select) {
      return;
    }

    this.select.addEventListener('change', this.onChange.bind(this), false);
    this.select.addEventListener('focus', this.onFocus.bind(this), false);
    this.select.addEventListener('blur', this.onBlur.bind(this), false);
  }

  onInit() {

    this.contentEl = this.el.querySelector('.label');

    if (!this.select) {
      return;
    }

    const optionElems = this.select.querySelectorAll('option');
    const ssOptionElems = this.el.querySelectorAll('.ss-option');
    const checkedOption = this.select.querySelector('option:checked');

    if (checkedOption) {
      const value = checkedOption.getAttribute('data-value') || checkedOption.text;
      const iconClassString = checkedOption.getAttribute('data-icon');
      const iconEl = '<i class="i-flag ' + iconClassString + '"></i>';
      this.contentEl.insertAdjacentHTML('beforebegin', iconEl);
      this.contentEl.textContent = value;
    }

    if (ssOptionElems && ssOptionElems.length) {
      this.ssOptions = [].slice.call(ssOptionElems);
      if (optionElems) {
        const optionArr = [].slice.call(optionElems);
        optionArr.map((option, index) => {

          const iconClassString = option.getAttribute('data-icon');
          const iconEl = '<i class="i-flag ' + iconClassString + '"></i>';

          this.ssOptions[index].insertAdjacentHTML('afterbegin', iconEl);
        });
      }
    }
  }

  onChange(e) {

    this.checkState();

    let option = this.select.querySelector('option:checked');

    if (!option) {

      option = this.select.options[0];
    }

    const value = option.getAttribute('data-value') || option.text;
    const href = option.getAttribute('data-href');

    this.contentEl.textContent = value;

    if (this.isIconDropdown) {

      // remove old icon first
      const icon = this.el.querySelector('i');
      if (icon) {

        icon.remove();
      }

      // add new icon
      if (option.getAttribute('data-icon')) {

        const iconClassString = option.getAttribute('data-icon');
        const iconEl = '<i class="i-flag ' + iconClassString + '"></i>';

        this.contentEl.insertAdjacentHTML('beforebegin', iconEl);
      }
    }

    if (href && !this.isSorting && !this.isAmount && e) {

      window.location.href = href;
    }

    this.handleAdditionalBehaviour(e, option);
  }

  checkState() {

    if (this.select.disabled) {

      this.el.classList.add('is-disabled');
    } else {

      this.el.classList.remove('is-disabled');
    }
  }

  handleAdditionalBehaviour(e, option) {

    if (!e) {

      return;
    }

    const lang = option.getAttribute('data-lang');
    let url = null;
    const urlType = option.getAttribute('data-url-type');

    if (lang) {

      const link = document.querySelector('link[hreflang="' + option.getAttribute('data-lang') + '"]');
      if (link) {

        url = link.href;
      } else {

        url = window.langUrls[lang];
      }
      const expires = new Date();
      expires.setTime(expires.getTime() + 1000 * 315360000);
      document.cookie = 'preferredLanguage=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      if (window.consent === undefined || window.consent.hasConsented.indexOf('preferences') >= 0) {

        document.cookie = `preferredLanguage=${encodeURIComponent(lang)};domain=${this.cookieDomain};path=/;max-age=315360000;expires=${expires.toUTCString()}`;
      }
    }

    if (url && url !== null) {

      // redirect
      if (!urlType && url !== '#') {

        window.location.href = url;
      } else {

        switch (urlType) {

        case 'currency':
          this.handleCurrency(option.getAttribute('data-val'));
          break;
        }
      }
    }
  }

  handleCurrency(data) {

    if (window.routes) {

      window.tcLoader.setActive();
      axios({
        method: window.routes.setCurrency[1],
        url: window.routes.setCurrency[0],
        data: {
          currency: data
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(res => {

          window.tcLoader.setInactive();
          window.location.reload();
          return false;
        })
        .catch(error => {
          throw `styleSelect.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
        });
    }
  }

  onFocus(e) {

    this.el.classList.add('is-focus');
  }

  onBlur(e) {

    this.el.classList.remove('is-focus');
  }
}
